export default function CustomerAgreementTemplate({
  placeholders,
}: {
  placeholders: any;
}) {
  return (
    <html>
      <head>
        <style>
          {`
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

            .paper {
              background: #fff;
              max-width: var(--page-width);
              margin: 30px auto;
              padding: var(--margin);
              box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
              color: #111;
              font-family: 'Inter', Arial, Helvetica, sans-serif;
            }

            .center { text-align: center; }
            .small { font-size: 12px; }
            .muted { color: #555; }

            h1, h2, h3, p, li, pre.contract-text,
            .site-header, .site-footer {
              font-family: 'Inter', Arial, Helvetica, sans-serif;
            }

            h1 {
              font-size: 24px;
              font-weight: 700;
              margin: 20px 0;
              text-align: center;
            }

            h2 {
              font-size: 18px;
              margin: 24px 0 12px;
              font-weight: 600;
              text-transform: uppercase;
            }

            h3 {
              font-size: 16px;
              margin: 18px 0 8px;
              font-weight: 600;
            }

            p {
              margin: 8px 0;
              line-height: 1.6;
            }

            .clause { margin: 12px 0; }

            ol.alpha { counter-reset: alpha; }

            ol.alpha > li {
              list-style: none;
              position: relative;
              padding-left: 28px;
              margin: 6px 0;
            }

            ol.alpha > li:before {
              counter-increment: alpha;
              content: counters(alpha, ".") ".";
              position: absolute;
              left: 0;
              top: 0;
              font-weight: 600;
            }

            .two-col {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 20px;
            }

            .signature {
              height: 90px;
              border-top: 1px solid #111;
              margin-top: 30px;
              padding-top: 8px;
            }

            .witness {
              display: flex;
              gap: 40px;
              margin-top: 22px;
            }

            .schedule {
              border-top: 1px dashed #ddd;
              padding-top: 12px;
              margin-top: 18px;
            }

            pre.contract-text {
              white-space: pre-wrap;
            }

            .page-break {
              page-break-before: always;
              break-before: page;
            }

            .site-header,
            .site-footer {
              width: 100%;
              padding: 10px 20px;
            }

            .site-header {
              border-bottom: 1px solid #333;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
            }

            .site-header img {
              height: 48px;
              width: auto;
              position: absolute;
              left: 20px;
              top: 50%;
              transform: translateY(-50%);
            }

            .site-header h1 {
              margin: 0;
              line-height: 1.35;
              font-size: 20px;
              text-align: center;
              font-weight: 600;
            }

            .site-footer {
              border-top: 1px solid #ccc;
              font-size: 12px;
              color: #555;
              text-align: center;
              position: relative;
            }

            .site-footer p {
              margin: 4px 0;
            }

            .assets-table-header {
              padding: 8px;
              text-align: left;
            }

            .assets-table-body {
              padding: 8px;
            }

            .date-style {
              margin: 20px 0px;
            }

            .party-section {
              margin: 20px 0;
              padding: 15px;
              border: 1px solid #ddd;
              border-radius: 4px;
            }

            .party-title {
              font-weight: 600;
              margin-bottom: 10px;
            }

            @media print {
              .paper {
                box-shadow: none;
                margin: 0;
                padding: 20mm;
                padding-top: 40mm;
                padding-bottom: 25mm;
              }

              .page-break {
                page-break-before: always;
                break-before: page;
              }

              .site-header,
              .site-footer {
                position: fixed;
                left: 0;
                right: 0;
              }

              .site-header { top: 0; }
              .site-footer { bottom: 0; }
              .site-header h1 { font-size: 18px; }

              .site-footer::after {
                content: "Page " counter(page) " of " counter(pages);
                position: absolute;
                right: 20mm;
                bottom: 6mm;
              }
            }
          `}
        </style>
      </head>
      <body>
        <header className="site-header">
          <h1>DRAUGHT BEER SUPPLY AGREEMENT</h1>
        </header>
        <article className="paper" id="contract">
          <div className="center">
            <h1>DRAUGHT BEER SUPPLY AGREEMENT</h1>
            <p>
              <strong>SELLER (BREWER / DISTRIBUTOR)</strong>
            </p>
            <div className="party-section">
              <p>
                <strong>Name:</strong>{" "}
                <span id="seller_name">{placeholders.SELLER_NAME}</span>
              </p>
              <p>
                <strong>Address:</strong>{" "}
                <span id="seller_address">{placeholders.SELLER_ADDRESS}</span>
              </p>
              <p>
                <strong>Authorised Signatory:</strong>{" "}
                <span id="seller_signatory">
                  {placeholders.SELLER_SIGNATORY}
                </span>
              </p>
            </div>

            <p>
              <strong>CLIENT (OUTLET OPERATOR)</strong>
            </p>
            <div className="party-section">
              <p>
                <strong>Name:</strong>{" "}
                <span id="client_name">{placeholders.CLIENT_NAME}</span>
              </p>
              <p>
                <strong>Address:</strong>{" "}
                <span id="client_address">{placeholders.CLIENT_ADDRESS}</span>
              </p>
              <p>
                <strong>Authorised Signatory:</strong>{" "}
                <span id="client_signatory">
                  {placeholders.CLIENT_SIGNATORY}
                </span>
              </p>
            </div>

            <p>
              <strong>Effective Date:</strong>{" "}
              <span id="effective_date">{placeholders.EFFECTIVE_DATE}</span>
            </p>
          </div>
          <section>
            <p className="clause">
              THIS DRAUGHT BEER SUPPLY AGREEMENT (this &quot;Agreement&quot;) is
              entered into on{" "}
              <span id="effective_date">{placeholders.EFFECTIVE_DATE}</span> by
              and between{" "}
              <span id="seller_name">{placeholders.SELLER_NAME}</span>, a
              company incorporated under applicable law and having its
              registered office at{" "}
              <span id="seller_address">{placeholders.SELLER_ADDRESS}</span>,
              represented by{" "}
              <span id="seller_signatory">{placeholders.SELLER_SIGNATORY}</span>{" "}
              (hereinafter the &quot;Seller&quot;); AND{" "}
              <span id="client_name">{placeholders.CLIENT_NAME}</span>, a
              licensed outlet operator having its registered office at{" "}
              <span id="client_address">{placeholders.CLIENT_ADDRESS}</span>,
              represented by{" "}
              <span id="client_signatory">{placeholders.CLIENT_SIGNATORY}</span>{" "}
              (hereinafter the &quot;Client&quot;).
            </p>

            <p className="clause">
              The Seller and the Client are hereinafter individually referred to
              as a &quot;Party&quot; and collectively as the
              &quot;Parties&quot;.
            </p>

            <h2>1. SCOPE OF AGREEMENT</h2>
            <p className="clause">
              The Seller agrees to supply draught beer in Kegs and to install
              and maintain a Dispenser at the Client&apos;s outlet located at{" "}
              <span id="outlet_address">{placeholders.OUTLET_ADDRESS}</span>{" "}
              (the &quot;Outlet&quot;), subject to the terms and conditions of
              this Agreement.
            </p>
            <p className="clause">
              The products covered under this Agreement include draught beer in
              Kegs of sizes 20L, 30L, or 50L (as ordered), CO₂ cylinders
              required for dispensing, and any ancillary equipment, collectively
              referred to as the &quot;Products&quot;.
            </p>
            <p className="clause">
              Upon receipt of a refundable advance deposit as specified in
              Schedule B, the Seller shall install the Dispenser, beer lines,
              and associated fittings at the Outlet. Any structural
              modifications required at the Outlet shall be at the Client&apos;s
              cost.
            </p>

            <h2>2. TERM</h2>
            <p className="clause">
              This Agreement shall come into effect on the Effective Date and
              shall continue until terminated by either Party in accordance with
              Clause 8.
            </p>

            <h2>3. SELLER OBLIGATIONS</h2>
            <h3>3.1 Dispenser Installation & Maintenance</h3>
            <ol className="alpha">
              <li>
                Install a Dispenser, beer lines, CO₂ cylinders, and all
                associated fittings at the Outlet in good working condition,
                upon receipt of the advance deposit.
              </li>
              <li>
                Provide training to the Client&apos;s designated staff on the
                correct operation of the Dispenser, proper Keg changeover, and
                CO₂ handling, within 7 days of installation.
              </li>
              <li>
                Conduct periodic inspection and preventive maintenance of the
                Dispenser and beer lines at the Seller&apos;s cost to ensure
                continued good working condition.
              </li>
              <li>
                Attend to breakdown or servicing requests within 72 hours of
                receiving written notification from the Client. Emergency
                call-outs during licensed operating hours shall be prioritised.
              </li>
              <li>
                Carry out sterilisation and cleaning of beer lines at prescribed
                intervals in accordance with applicable food safety and hygiene
                standards.
              </li>
            </ol>

            <h3>3.2 Keg Supply</h3>
            <ol className="alpha">
              <li>
                Supply Kegs of draught beer (20L / 30L / 50L, as specified in
                each order) in accordance with the pricing set out in Schedule
                B, subject to availability.
              </li>
              <li>
                Deliver Kegs sealed and intact, with the seal and collar intact
                at the time of delivery. The Seller shall replace, at no charge,
                any Keg found damaged or with a broken seal at the point of
                delivery, provided the Client notifies the Seller within 24
                hours of receipt.
              </li>
              <li>
                Raise an invoice upon receipt of each order and fulfil delivery
                within the timeline agreed in Schedule B.
              </li>
              <li>
                In the event of non-payment, charge interest at the rate stated
                in Schedule B on overdue amounts, and reserve the right to
                suspend supply until all outstanding dues are settled.
              </li>
            </ol>

            <h2>4. CLIENT OBLIGATIONS</h2>
            <p className="clause">
              The Client shall, throughout the term of this Agreement:
            </p>
            <ol className="alpha">
              <li>
                Hold and maintain in full force all licences, permits, and
                registrations required to sell, store, and serve alcohol,
                including applicable excise licences and FSSAI registration, and
                provide copies to the Seller on request.
              </li>
              <li>
                Place written orders specifying Keg size and quantity, and pay
                all invoiced amounts including applicable excise duties, taxes,
                and delivery charges in advance or as agreed in Schedule B.
              </li>
              <li>
                Store all Kegs in a dedicated cold room or refrigerated area
                maintained at a temperature between 6°C and 8°C, away from
                direct sunlight and heat sources.
              </li>
              <li>
                Consume the contents of each Keg within 10 days of unsealing.
                Any Keg left unsealed beyond 10 days shall be deemed consumed
                and shall not be eligible for return, exchange, or credit.
              </li>
              <li>
                Inspect each Keg at the time of delivery and verify that the
                seal, collar, and outer packaging are intact. Any discrepancy
                must be reported in writing within 24 hours.
              </li>
              <li>
                Use the Dispenser exclusively for serving the Seller&apos;s
                draught beer brands. The Client shall not use the Dispenser to
                serve any third-party or competing beer brand without prior
                written consent of the Seller.
              </li>
              <li>
                Not alter, modify, tamper with, or attempt to repair the
                Dispenser or beer lines without the Seller&apos;s prior written
                approval. All servicing must be carried out solely by the
                Seller&apos;s authorised technicians.
              </li>
              <li>
                Permit the Seller and its authorised representatives to inspect
                the Outlet, the Dispenser, Keg storage area, and beer lines at
                all reasonable times and without prior notice.
              </li>
              <li>
                Return the Dispenser, CO₂ cylinders, and all ancillary equipment
                supplied by the Seller in clean condition and in good working
                order (subject to fair wear and tear) upon termination of this
                Agreement.
              </li>
              <li>
                Not represent to any third party any ownership interest in the
                Dispenser or any other equipment supplied by the Seller.
              </li>
            </ol>

            <h2>5. TITLE AND INTELLECTUAL PROPERTY</h2>
            <p className="clause">
              The Seller retains full ownership, title, and all intellectual
              property rights in the Dispenser, beer lines, CO₂ cylinders, Keg
              hardware, and all brand elements including trademarks, labels,
              font badges, and promotional materials supplied under this
              Agreement. The Client is granted a limited, non-exclusive licence
              to display the Seller&apos;s brand identity at the Outlet solely
              for the purpose of promoting the sale of the Seller&apos;s draught
              beer during the term of this Agreement. The Client shall not
              alter, re-label, or misrepresent the Seller&apos;s branding and
              shall promptly notify the Seller of any known or suspected
              third-party infringement.
            </p>

            <h2>6. CONFIDENTIALITY</h2>
            <p className="clause">
              Each Party shall treat all information disclosed by the other in
              connection with this Agreement as strictly confidential, including
              pricing, outlet performance data, and technical specifications,
              and shall not disclose it to any third party except as required by
              law. This obligation survives the termination or expiry of this
              Agreement for a period of three (3) years.
            </p>

            <h2>7. INDEMNIFICATION AND LIABILITY</h2>
            <p className="clause">
              The Client shall indemnify and hold harmless the Seller against
              all claims, losses, damages, penalties, and costs arising from:
              (a) the Client&apos;s breach of any obligation under this
              Agreement; (b) improper storage, handling, or serving of Kegs or
              beer; (c) the Client&apos;s failure to maintain required licences;
              or (d) any violation of applicable excise, food safety, or
              environmental laws at the Outlet. The Seller&apos;s total
              liability under this Agreement shall not exceed the amount of the
              deposit paid by the Client.
            </p>

            <h2>8. TERMINATION</h2>
            <h3>8.1 By the Seller</h3>
            <p className="clause">
              For convenience: 7 days&apos; written notice.
              <br />
              With immediate effect: upon material breach by the Client that is
              not remedied within 7 days of written notice; loss or suspension
              of any required excise licence or FSSAI registration; use of the
              Dispenser for competing brands without consent; cessation of
              operations; or change of control to a competitor of the Seller.
            </p>

            <h3>8.2 By the Client</h3>
            <p className="clause">
              For convenience: 30 days&apos; written notice.
            </p>

            <h3>8.3 Consequences of Termination</h3>
            <p className="clause">
              The Client shall immediately cease using the Seller&apos;s
              Dispenser, branding, and promotional materials, and shall ensure
              all Kegs and equipment are made available for collection.
            </p>
            <p className="clause">
              The Seller shall recover the Dispenser, CO₂ cylinders, beer lines,
              and all ancillary equipment, and shall refund the deposit after
              deducting the cost of any damage caused by the Client beyond fair
              wear and tear.
            </p>
            <p className="clause">
              Any unsealed Kegs remaining at the Outlet at the time of
              termination shall be settled as per agreed pricing and shall not
              be eligible for return.
            </p>
            <p className="clause">
              Both Parties shall return or destroy all Confidential Information
              of the other Party.
            </p>

            <h2>9. GOVERNING LAW AND DISPUTE RESOLUTION</h2>
            <p className="clause">
              This Agreement is governed by the laws of India, including
              applicable state excise laws and the Food Safety and Standards
              Act, 2006. Disputes shall first be resolved by amicable
              negotiation within 15 days of written notice. Unresolved disputes
              shall be referred to sole arbitration under the Arbitration and
              Conciliation Act, 1996, seated in Bangalore, conducted in English.
              Arbitral awards are final and binding. Courts at Bangalore shall
              have exclusive jurisdiction.
            </p>

            <h2>10. GENERAL</h2>
            <p className="clause">
              <strong>Independent Parties:</strong> Nothing herein creates a
              partnership, agency, joint venture, or fiduciary relationship.
            </p>
            <p className="clause">
              <strong>Non-exclusive:</strong> The Seller may supply draught beer
              to other outlets. The Client may source non-beer or non-draught
              beverages from other suppliers, subject to the brand exclusivity
              obligation in Clause 4.
            </p>
            <p className="clause">
              <strong>Assignment:</strong> Neither Party may assign its rights
              or obligations without the other&apos;s prior written consent.
            </p>
            <p className="clause">
              <strong>Amendment:</strong> Any modification must be agreed in
              writing and signed by authorised representatives of both Parties.
            </p>
            <p className="clause">
              <strong>Entire Agreement:</strong> This Agreement (including
              Schedules) constitutes the entire understanding between the
              Parties and supersedes all prior arrangements relating to draught
              beer supply.
            </p>
            <p className="clause">
              <strong>Severability:</strong> If any provision is found
              unenforceable, the remaining provisions continue in full force.
            </p>

            <div className="schedule">
              <h2>SCHEDULE A - PRODUCTS AND OUTLET DETAILS</h2>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  margin: "20px 0",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5" }}>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      S. No
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      Product / Item
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      Keg Size / Spec
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      Qty
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      Unit
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      1
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Draught Beer - Keg
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      20L / 30L / 50L
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Keg
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      2
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      CO₂ Cylinder
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Unit
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      3
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Dispenser + Beer Lines (equipment)
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      1
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Set
                    </td>
                  </tr>
                </tbody>
              </table>

              <p>
                <strong>Outlet Address:</strong>{" "}
                <span id="outlet_address">{placeholders.OUTLET_ADDRESS}</span>
              </p>
              <p>
                <strong>Keg Delivery Timeline:</strong> Within ___ business days
                of confirmed order and advance payment.
              </p>
              <p>
                <strong>Keg Storage Requirement:</strong> 6°C - 8°C,
                refrigerated cold room, away from direct sunlight.
              </p>
              <p>
                <strong>Post-Unsealing Consumption Window:</strong> 10 days from
                date of unsealing.
              </p>
            </div>

            <div className="schedule">
              <h2>SCHEDULE B - PRICING AND PAYMENT TERMS</h2>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  margin: "20px 0",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5" }}>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      S. No
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      Item
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      Keg Size
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      Price (INR)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      1
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Draught Beer Keg
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      20L
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      2
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Draught Beer Keg
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      30L
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      3
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Draught Beer Keg
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      50L
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      4
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      CO₂ Cylinder (exchange)
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    ></td>
                  </tr>
                </tbody>
              </table>

              <p>
                <strong>Dispenser Deposit:</strong> INR{" "}
                <span id="deposit_amount">{placeholders.DEPOSIT_AMOUNT}</span>{" "}
                (refundable, subject to Clause 8.3).
              </p>
              <p>
                <strong>Interest on Overdue Payments:</strong> ___% per annum
                from the date of default.
              </p>
              <p>
                <strong>Payment Terms:</strong> Advance payment per order / Net
                ___ days (as agreed in writing).
              </p>
              <p>
                All prices are exclusive of applicable excise duties, taxes, and
                statutory levies, which shall be borne by the Client.
              </p>
            </div>

            <h2>SIGNATURES</h2>
            <p className="center">
              IN WITNESS WHEREOF the Parties have signed this Agreement on the
              Effective Date.
            </p>

            <div className="two-col" style={{ marginTop: "40px" }}>
              <div>
                <p>
                  <strong>For and on behalf of the Seller</strong>
                </p>
                <p>
                  Name: <span id="seller_name">{placeholders.SELLER_NAME}</span>
                </p>
                <div className="signature">
                  Signature: _______________________________
                </div>
                <p>
                  Authorised Signatory:{" "}
                  <span id="seller_signatory">
                    {placeholders.SELLER_SIGNATORY}
                  </span>
                </p>
                <p>
                  Date:{" "}
                  <span id="effective_date">{placeholders.EFFECTIVE_DATE}</span>
                </p>
              </div>

              <div>
                <p>
                  <strong>For and on behalf of the Client</strong>
                </p>
                <p>
                  Name: <span id="client_name">{placeholders.CLIENT_NAME}</span>
                </p>
                <div className="signature">
                  Signature: _______________________________
                </div>
                <p>
                  Authorised Signatory:{" "}
                  <span id="client_signatory">
                    {placeholders.CLIENT_SIGNATORY}
                  </span>
                </p>
                <p>
                  Date:{" "}
                  <span id="effective_date">{placeholders.EFFECTIVE_DATE}</span>
                </p>
              </div>
            </div>

            <div className="witness">
              <div>
                <p>
                  <strong>Witness</strong>
                </p>
                <div className="signature">
                  Signature: _______________________________
                </div>
                <p>Name: _______________________________</p>
                <p>Date: _______________________________</p>
              </div>

              <div>
                <p>
                  <strong>Witness</strong>
                </p>
                <div className="signature">
                  Signature: _______________________________
                </div>
                <p>Name: _______________________________</p>
                <p>Date: _______________________________</p>
              </div>
            </div>
          </section>
        </article>
        <footer className="site-footer">
          <p>DRAUGHT BEER SUPPLY AGREEMENT | Confidential</p>
        </footer>
      </body>
    </html>
  );
}
